export default "__VITE_ASSET__BldhEk6t__"